// @flow
import ListFooterCellRenderer from './ListFooterCellRenderer';

export default ListFooterCellRenderer;
